// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"252":"6abc66","751":"4cee47","878":"6aa726"}[chunkId] + ".js";
};